import { action, makeObservable, observable } from 'mobx';

export class AutocompleteViewModel<TValue extends unknown = unknown> {
   opened = false;
   value: TValue | null = null;
   search: string = '';
   private getLabel?: (item: TValue) => string;
   onValueChange?: (values: TValue | null) => void;
   constructor(
      value: null = null,
      options: {
         maxSelected?: number;
         getLabel?: (value: TValue) => string;
         onValueChange?: (values: TValue | null) => void;
      }
   ) {
      makeObservable(this, {
         value: observable,
         opened: observable,
         search: observable,
         onOpenedChange: action.bound,
         onSelect: action.bound,
         onSearch: action.bound,
         clearSearch: action.bound,
      });
      if (value) {
         this.value = value;
      }
      this.getLabel = options?.getLabel;
      this.onValueChange = options?.onValueChange;
   }

   onOpenedChange(o: boolean): void {
      this.opened = o;
   }

   onSelect(value: TValue): void {
      this.value = value;
      this.search = this.getLabel?.(this.value) ?? '';
      this.onValueChange?.(this.value);
   }

   clearValue(): void {
      this.value = null;
      this.onValueChange?.(this.value);
   }

   onSearch(value: string): void {
      this.search = value;
      this.value = null;
   }

   clearSearch(): void {
      this.search = '';
   }
}
